(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/prescript.js');

svs.ui = svs.ui || {};
svs.ui.form = svs.ui.form || {};
svs.ui.reactForm = svs.ui.reactForm || {};
svs.ui.ReactForm = svs.ui.reactForm;


 })(window);